<div class="flex justify-end pr-[0.25em]">
  <app-pan-button
    color="primary"
    icon="summarize"
    (click)="onSummaryClick()"
    matTooltip="AR Summary"
    data-testid="ar-summary-button"
  ></app-pan-button>
</div>
